import useFeatureFlagValue from '@/components/analytics/hooks/useFeatureFlagValue';

export const PD6990_REPLACE_SIGN_UP_CONTACT_PERMISSION_WITH_CHECKBOX_FLAG =
  'pd-6990-replace-sign-up-contact-permission-with-checkbox';

/**
 * PD-6990: Replace sign-up contact permission with checkbox.
 *
 * GrowthBook serves true for the checkbox treatment. The fallback is false so a disabled or missing flag keeps the Yes/No contact-permission radio.
 *
 * Permanent backend rollout and frontend cleanup are documented in this directory's README.
 *
 * @see https://firsttable.atlassian.net/browse/PD-6990
 * @see https://app.growthbook.io/features/pd-6990-replace-sign-up-contact-permission-with-checkbox
 * @see https://app.growthbook.io/experiment/exp_19g6dmuyoo57a
 */
export default function usePD6990ReplaceSignUpContactPermissionWithCheckboxExperiment(): boolean {
  return (
    useFeatureFlagValue(PD6990_REPLACE_SIGN_UP_CONTACT_PERMISSION_WITH_CHECKBOX_FLAG, false) ===
    true
  );
}
